import angular = require("angular");
import TPL = require("templates");
import {Config} from "../../config";
import {SessionService} from "../../services/session";
import {ConfirmController} from "../../modals/confirm";
import {LinkList} from "./link";

export class MenuItem {

  callback: ()=> void;
  label: string;
  linkUrl: string;
  constructor() {}

  static createMenuItem(label: string, linkUrl: string, callback: ()=>void): MenuItem {
    var result = new MenuItem();
    result.label = label;
    result.callback = callback;
    result.linkUrl = linkUrl;
    return result;
  }
}

export class MenuItemList extends Array<MenuItem> {
  constructor() {
    super();
  }

  static buildMenu(session: SessionService, location, modal, rootScope) {
    var result = new MenuItemList();
    var hosted;

    if(session.isHost()) {
      hosted = "#" + Config.manage + "/" + Config.hosted;
    } else {
      hosted = "#" + Config.manage + "/" + Config.upcoming;
    }

    result.push(MenuItem.createMenuItem("MENU.MANAGE_EVENTS", hosted, ()=>{
    }));

    result.push(MenuItem.createMenuItem("MENU.CREATE_DINNER", Config.linkHash + Config.events, ()=>{}));

    result.push(MenuItem.createMenuItem("MENU.SETTINGS", Config.linkHash + Config.profile, ()=>{}));

    result.push(MenuItem.createMenuItem("MENU.LOGOUT", Config.linkHash + Config.home, ()=>{
      session.logout();
    }));

    return result;
  }
}

export class UserRecapDirective {

  scope = {
    params: "=params"
  };
  template;
  link;

  constructor(session, $location, $modal, $rootScope, $log) {
    this.template = TPL.navigationDirectives.userRecap;

    this.link = (scope, el, attrs) => {
        scope.vm = {
          session: session,
          menuItemList: MenuItemList.buildMenu(session, $location, $modal, $rootScope)
        };

        scope.$watch(() => {return session.isHost();}, () => {
          //$log.debug("IsHost: " + session.isHost());
          scope.vm.menuItemList = MenuItemList.buildMenu(session, $location, $modal, $rootScope);
        })
    }
  }

  static factory() {
    var tmp = (a, b, c, d, e) => new UserRecapDirective(a, b, c, d, e);
    tmp.$inject = ["session", "$location", "$uibModal", "$rootScope", "$log"];
    return tmp;
  }
}



/** WEBPACK FOOTER **
 ** ./src/scripts/directives/navigation/userRecap.ts
 **/